
export const TYPES = [
	{ value:'default', label: '기본 메뉴' },
	{ value:'page', label: '페이지' },
	{ value:'category', label: '카테고리' },
	{ value:'tag', label: '태그 검색' },
	{ value:'url', label: '직접 입력' },
]

export const defaultType = () => TYPES[TYPES.length - 1]
